import {
	requestTablet3List,
	registTablet3,
	requestTablet3Delete
} from "@/apis/tablet3_api";

const state = {
	tablet3List: [],
	tablet3Page: null,
	tablet3PageTotal: 0,
	tablet3TotalElemtnts: 0,
};

const getters = {
	getTablet3List(state) {
		return state.tablet3List;
	},
	getTablet3Page(state) {
		if (state.tablet3Page === null) {
			return 0;
		} else {
			return state.tablet3Page.pageNumber + 1;
		}
	},
	getTablet3PageTotal(state) {
		return state.tablet3PageTotal;
	},
	getTablet3TotalElements(state) {
		return state.tablet3TotalElemtnts;
	},
};

const mutations = {
	TABLET3_LIST(state, data) {
		state.tablet3List = data.resultTablet3List
		state.tablet3Page = data.page
		state.tablet3PageTotal = data.pageTotal
		state.tablet3TotalElemtnts = data.totalElemtnts
	},
	TABLET3_LIST_ADD(state, data) {
		state.tablet3List = [].concat.apply(state.tablet3List, data.resultTablet3List);
		state.tablet3Page = data.page
		state.tablet3PageTotal = data.pageTotal
		state.tablet3TotalElemtnts = data.totalElemtnts
	},
	TABLET3_INIT(state) {
		state.tablet3List = []
		state.tablet3Page = null
		state.tablet3PageTotal = 0
		state.tablet3TotalElemtnts = 0
	}
};

const actions = {
	async REQUEST_TABLET3_DELETE(context, id) {
		try {
			context.commit('START_LOADING');
			const response = await requestTablet3Delete(id);
			if (response.data !== null && response.data !== undefined && response.data.result === 'success') {
				context.commit("TABLET3_LIST", response.data);
			} else {
				alert(response.data.message);
			}
			context.commit('END_LOADING');
		} catch (e) { if(e==='refresh'){ return }
			context.commit('END_LOADING');
		}
		context.commit('END_LOADING');
	},
	async REQUEST_TABLET3_LIST(context, parameter) {
		try {
			context.commit('START_LOADING');
			const response = await requestTablet3List(parameter);
			if (response.data !== null && response.data !== undefined && response.data.result === 'success') {
				context.commit("TABLET3_LIST", response.data);
			} else {
				alert(response.data.message);
			}
			context.commit('END_LOADING');
		} catch (e) { if(e==='refresh'){ return }
			context.commit('END_LOADING');
		}
		context.commit('END_LOADING');
	},
	async REGIST_TABLET3(context, parameter) {
		try {
			context.commit('START_LOADING');
			const response = await registTablet3(parameter);
			if (response.data !== null && response.data !== undefined && response.data.result === 'success') {

			} else {
				alert(response.data.message);
			}
			context.commit('END_LOADING');
		} catch (e) { if(e==='refresh'){ return }
			context.commit('END_LOADING');
		}
		context.commit('END_LOADING');
	},
};

export default { mutations, state, actions, getters };